import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef
} from '@angular/core';
import { GenericObject } from 'src/app/interfaces/generic-object';

@Component({
  selector: 'app-display-card-column',
  templateUrl: './display-card-column.component.html',
  styleUrls: ['./display-card-column.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
// This component is used to show a collection of display-card components in a scrollable column
export class DisplayCardColumnComponent implements OnInit {
  constructor() {}

  // This can be a collection of anything. The programmer defines how to display the item collection
  // when instantiating the component in an html file.
  @Input() itemCollection: any[] = [];
  // This is used to set the height for the display-card component used in this component.
  @Input() displayCardPanelHeight: 'fit' | 'fill' = 'fill';
  // Can pass a set of items that represent selections. This collection must contain items from the
  // itemCollection.
  @Input() SelectedItems = new Set<any>();

  // Display a default card style across all cards. This isn't ideal, should instead migrate towards
  // updating the item collection to contain a data record and a style record.
  @Input() cardStyle?: GenericObject;

  @ContentChild(TemplateRef) templateRef!: TemplateRef<any>;

  isSelected(item: any) {
    return this.SelectedItems.has(item);
  }

  ngOnInit(): void {}
}
